<template>
    <div>
        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin:PagePrivacy -->
                    <div id="main" class="col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle"></i></span>{{ titleinfo[getCurrentLocale] }}</h1>
                        </div>
                        <br />

                        <div class="booking-information sdr-box">
                            <h4 v-html="goods_h4[getCurrentLocale]"></h4>
                            <h5 v-html="goods_h5_1[getCurrentLocale]"></h5>


                            <p v-html="goods_p_1[getCurrentLocale]"></p>
                            <p v-html="goods_p_2[getCurrentLocale]"></p>


                            <br /><h5 v-html="goods_h5_2[getCurrentLocale]"></h5>
                            <p v-html="goods_h5_21[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="goods_li_1[getCurrentLocale]"></li>
                                <li v-html="goods_li_2[getCurrentLocale]"></li>
                                <li v-html="goods_li_3[getCurrentLocale]"></li>
                                <li v-html="goods_li_4[getCurrentLocale]"></li>
                                <li v-html="goods_li_5[getCurrentLocale]"></li>
                                <li v-html="goods_li_6[getCurrentLocale]"></li>
                                <li v-html="goods_li_7[getCurrentLocale]"></li>
                                <li v-html="goods_li_8[getCurrentLocale]"></li>
                                <li v-html="goods_li_9[getCurrentLocale]"></li>
                                <li v-html="goods_li_10[getCurrentLocale]"></li>
                                <li v-html="goods_li_11[getCurrentLocale]"></li>
                                <li v-html="goods_li_12[getCurrentLocale]"></li>
                                <li v-html="goods_li_13[getCurrentLocale]"></li>
                                <li v-html="goods_li_14[getCurrentLocale]"></li>
                                <li v-html="goods_li_15[getCurrentLocale]"></li>
                                <li v-html="goods_li_16[getCurrentLocale]"></li>
                            </ul>


                            <br /><h5 v-html="goods_h5_3[getCurrentLocale]"></h5>
                            <p v-html="goods_p_3[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="goods_li_17[getCurrentLocale]"></li>
                                <li v-html="goods_li_18[getCurrentLocale]"></li>
                                <li v-html="goods_li_19[getCurrentLocale]"></li>
                                <li v-html="goods_li_20[getCurrentLocale]"></li>
                                <li v-html="goods_li_21[getCurrentLocale]"></li>
                            </ul>
                            <p v-html="goods_p_4[getCurrentLocale]"></p>
                            <p v-html="goods_p_5[getCurrentLocale]"><p>
                            <p><a href="https://www.lba.de/DE/Betrieb/Gefahrgut/Passagierinformation/Passagierinformation_node.html" target="_new">https://www.lba.de/DE/Betrieb/Gefahrgut/Passagierinformation/Passagierinformation_node.html</a></p>
                        </div>
                    </div>
                    <!-- End:PagePrivacy -->

                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent -->


        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                titleinfo: {
                    en: 'Information on the transport of dangerous goods',
                    de: 'Informationen zur Beförderung gefährlicher Gegenstände',
                },
                // >>> --------------------------
                goods_h4: {
                    en: 'Information about travelling with dangerous goods',
                    de: 'Informationen zur Beförderung gefährlicher Gegenstände',
                },
                goods_h5_1: {
                    en: 'Dangerous goods',
                    de: 'Gefährliche Gegenstände',
                },
                goods_p_1: {
                    en: 'In aviation some usual items from the normal everyday life could be so dangerous, that it isn’t allowed taken them neither on aircraft nor within travelling baggage.',
                    de: 'Im Luftverkehr können viele Gegenstände aus dem normalen Alltag zu einer derartigen Gefahr werden, dass sie an Bord eines Flugzeuges weder im Handgepäck noch im Reisegepäck zugelassen sind.',
                },
                goods_p_2: {
                    en: 'The transport of dangerous goods is subject to the strictest regulations.',
                    de: 'Der Transport von gefährlichen Gegenständen unterliegt strengsten Vorschriften.',
                },
                // >>> --------------------------
                goods_h5_2: {
                    en: 'According to ICAO/ IATA regulations, dangerous goods within baggage is strictly forbidden',
                    de: 'Gefährliche Gegenstände sind gemäß ICAO / IATA-Vorschriften im Gepäck verboten',
                },
                goods_h5_21: {
                    en: 'Dangerous goods may be:',
                    de: 'Als gefährliche Güter gelten:',
                },
                goods_li_1: {
                    en: 'Smartphones type Samsung Galaxy Note 7. These smartphones must turn off and it isn’t allowed load them during flight',
                    de: 'Smartphones des Typs Samsung Galaxy Note 7. Diese Smartphones müssen an Bord komplett ausgeschaltet sein und dürfen nicht aufgeladen werden.',
                },
                goods_li_2: {
                    en: 'Briefcases with integrate alert and also integrate Lithium-batteries or pyrotechnic material',
                    de: 'Aktenkoffer mit eingebauter Alarmanlage und integrierten Lithium-Batterien oder pyrotechnischem Material',
                },
                goods_li_3: {
                    en: 'Explosives, Fireworks, Torches, light- or smoke signals',
                    de: 'Explosivstoffe, Feuerwerkskörper, Fackeln, Leucht- oder Rauchsignale',
                },
                goods_li_4: {
                    en: 'Containers with gases (flammable or non flammable, frozen, liquidized or toxic), for example protection spray, Stove, filled pressure bottles, lighter gas, soda patrons',
                    de: 'Behälter mit Gasen (entflammbar oder nicht entflammbar, tiefgefroren, verflüssigt oder giftig), beispielsweise Reizgase, Selbstverteidigungsspray, Campinggas, gefüllte Druckflaschen, Feuerzeuggas, Soda-Patronen',
                },
                goods_li_5: {
                    en: 'Containers with flammable liquids, e.g. lighter- or wash petrol, colors, varnish, adhesives, dilution fluids, detergents, heating fluids',
                    de: 'Behälter mit entflammbaren Flüssigkeiten, z. B. Feuerzeug- oder Waschbenzin, Farben, Lacke, Klebstoffe, Verdünnungsflüssigkeiten, Reinigungsmittel, Heizflüssigkeiten',
                },
                goods_li_6: {
                    en: 'Flammable and highly flammable substances, e.g. matches',
                    de: 'Entflammbare und leicht entzündliche Stoffe, z. B. Streichhölzer',
                },
                goods_li_7: {
                    en: 'E-cigarettes (must only carried within hand luggage or on body from traveler on every flight)',
                    de: 'E-Zigaretten (Diese dürfen auf allen Flügen ausschließlich im Handgepäck oder am Körper des Reisenden mitgeführt werden.)',
                },
                goods_li_8: {
                    en: 'Substances which become flammable gases if they get in touch with water',
                    de: 'Substanzen, die bei Kontakt mit Wasser entflammbare Gase entwickeln',
                },
                goods_li_9: {
                    en: 'Oxidizing substances, e.g. bleaching powder, superoxide',
                    de: 'Oxidierende Stoffe, z. B. Bleichpulver, Superoxid',
                },
                goods_li_10: {
                    en: 'Toxic and infectious substances, e.g. quicksilver, bacteria- and virus culture',
                    de: 'Giftige (toxische) und ansteckende Stoffe, z. B. Quecksilber, Bakterien- und Viruskulturen',
                },
                goods_li_11: {
                    en: 'Radioactive substances and articles',
                    de: 'Radioaktive Stoffe und Gegenstände',
                },
                goods_li_12: {
                    en: 'Corrosive substances, e.g. acid, alkali/base, spillable batteries',
                    de: 'Ätzende Stoffe, z. B. Säuren, Laugen/Basen, Nassbatterien',
                },
                goods_li_13: {
                    en: 'High magnetic material',
                    de: 'Stark magnetische Materialien',
                },
                goods_li_14: {
                    en: 'Gas-operated devices and tools which already contained the smallest quantity of gasoline (e.g. test purposes)',
                    de: 'Benzinbetriebene Geräte und Werkzeuge, die bereits kleinste Mengen Benzin enthalten haben (z.B. für Testzwecke)',
                },
                goods_li_15: {
                    en: 'Electro shock weapons, e.g. Taser',
                    de: 'Elektroschockwaffen, z.B. Elektro-Schocker (Taser)',
                },
                goods_li_16: {
                    en: 'Lithium battery or accumulator (It is allowed to carried maximum 2 single Lithium batteries or rechargeable batteries up to 160 Wh as spare cells for electronical consumer goods (e.g. laptops, mobile phones, watches or cameras). The Airline‘s prior consent must be obtained if separate batteries or rechargeable batteries with an individual rating of between 100 Wh and 160 Wh are to be carried on board.',
                    de: 'Lithium-Batterien oder Akkumulatoren (Es dürfen höchstens zwei einzelne Lithium-Batterien oder Akkumulatoren mit einer Wattstundenleistung bis 160Wh als Ersatzzellen für elektronische Gebrauchsgüter (z.B in Laptops, Mobiltelefonen, Uhren, Kameras) befördert werden. Die Beförderung von einzelnen Batterien oder Akkumulatoren mit einer Wattstundenleistung von 100Wh bis 160 Wh bedarf der vorherigen Zustimmung der Fluggesellschaft.)',
                },
                // >>> --------------------------
                goods_h5_3: {
                    en: 'The transport of means of transport which are lithium-batterie operated is strictly forbidden',
                    de: 'Die Beförderung Lithium-batteriebetriebener Fortbewegungsmittel ist verboten',
                },
                goods_p_3: {
                    en: 'The transport of electronical means of transport, which are operated with lithium batteries, isn’t allowed in checked baggage as well as carry on baggage on aircraft. This regulation is applicable irrespective from capacity from the batterie.<br />To these types of means of transport belongs e.g.:',
                    de: 'Die Beförderung von elektronischen Fortbewegungsmitteln, die mit Lithium-Batterien betrieben werden, ist sowohl in aufgegebenem Gepäck, als auch im Handgepäck an Bord von Flugzeugen untersagt. Diese Regelung gilt unabhängig von der Leistung der Batterie.<br />Zu dieser Art der Fortbewegungsmittel gehören u.a.:',
                },
                goods_li_17: {
                    en: 'Hoverboards',
                    de: 'Hoverboards',
                },
                goods_li_18: {
                    en: 'Segways',
                    de: 'Segways',
                },
                goods_li_19: {
                    en: 'Airwheels and Solowheels',
                    de: 'Airwheels und Solowheels',
                },
                goods_li_20: {
                    en: 'Baggage scooter',
                    de: 'Gepäckscooter',
                },
                goods_li_21: {
                    en: 'E-bikes with lithium batterie',
                    de: 'Elektrofahrräder mit Lithium-Batterien',
                },
                goods_p_4: {
                    en: 'Wheelchairs or other mobility aids, which are powered through lithium batteries, are non effected from it’s prohibition but it’s notifiable.',
                    de: 'Rollstühle oder andere Mobilitätshilfen, die durch Lithium Batterien angetrieben werden, sind von diesem Verbot nicht betroffen, jedoch anmeldepflichtig.',
                },
                goods_p_5: {
                    en: 'More information in regard of transportation of dangerous goods are subject to ICAO Dangerous Goods Regulations which can be found on website of LuftfahrtBundesamt.',
                    de: 'Ausführliche Informationen zur Gefahrgutbeförderung sind den internationalen Gefahrgutvorschriften der ICAO zu entnehmen, welche über die Internetseiten des Luftfahrt-Bundesamtes eingesehen werden können.',
                },
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    ul.arrow, ul.triangle, ul.circle, ul.check, ul.chevron, ul.arrow-square, ul.check-square, ul.check-circle, ul.decimal, ul.upper-roman, ul.lower-latin, ul.upper-latin {
        font-size: 1.0833em;
    }





    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.6em;
        }
        .booking-information {
            padding: 20px 30px 30px;
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 30px;
            padding-left: 15px;
        }
    }
</style>